import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Siniestros from "../../../views/Seguridad/Siniestros/Siniestros";
import ExcesoVelocidad from "../../../views/Incidencias/ExcesosVelocidad/ExcesoVelocidad";
import Desconexiones from "../../../views/Seguridad/Desconexiones/Desconexiones";
import MonitorFatiga from "../../../views/Seguridad/MonitorFatiga/MonitorFatiga";


const Seguridad = () => {
    return (
        <Suspense fallback={<>Cargando...</>}>
            <Routes>
                <Route path="seguridad/siniestro" element={<Siniestros />} />
                <Route path="seguridad/desconexiones" element={<Desconexiones />} />
                <Route path="seguridad/monitor-fatiga" element={<MonitorFatiga />} />
                <Route path="seguridad/exceso-velocidad" element={
                    <Suspense fallback={<>skeleton</>}>
                        <ExcesoVelocidad></ExcesoVelocidad>
                    </Suspense>
                } />
            </Routes>
        </Suspense>
    );
};

export default Seguridad;
